import { render, staticRenderFns } from "./EntityTree.vue?vue&type=template&id=34489537&"
import script from "./EntityTree.vue?vue&type=script&lang=js&"
export * from "./EntityTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports